import Model from "@/models/Model";

export default class Rating extends Model {
    resource() {
        return "ratings";
    }

    baseURL() {
        return super.baseURL() + "/resourcecenter";
    }
}
